/**
 * MobileWaiverWizard — thin wrapper around the shared WaiverFlow.
 * Booking mode: signs the waiver against a booking from the customer ticket.
 * The flow itself (steps, OTP, phone/email inputs) lives in WaiverFlow.jsx.
 */
import React from 'react';
import WaiverFlow from './WaiverFlow';
import api from '../utils/api';
import { trackCompleteRegistration } from '../utils/trackingUtils';

const MobileWaiverWizard = ({
  trip,
  onClose,
  organizationName,
  orgBranding,
  customWaiverText,
  brandColor = '#2563EB',
  onSuccess,
  waiverVersion = '1.0',
  trackingConfig = {},
  region = 'USA',
}) => {
  const handleSubmit = async (p) => {
    const code = trip.confirmationCode || trip.id;
    const pin = code.replace(/[^0-9]/g, '').slice(-3).padStart(3, '0');
    await api.post(`/v2/public/bookings/${code}/sign-waiver`, {
      signature: p.signerName,
      signatureName: p.signerName,
      signatureData: p.signatureData,
      verified: p.verified,
      verificationMethod: p.verificationMethod,
      verifiedContact: p.verifiedContact,
      phoneNumber: p.phoneNumber,
      email: p.email,
      deviceInfo: p.deviceInfo,
      pin,
      idVerificationRequired: p.idVerificationRequired || undefined,
      signedAt: p.signedAt,
      waiverVersion,
      ageRange: p.ageRange,
      marketingOptIn: p.marketingOptIn,
      marketingConsentText: p.marketingConsentText,
    });
    if (trackingConfig.googleAdsId || trackingConfig.metaPixelId) {
      trackCompleteRegistration({
        googleAdsId: trackingConfig.googleAdsId,
        googleAdsLabel: trackingConfig.googleAdsLabel,
        metaPixelId: trackingConfig.metaPixelId,
        contentId: code,
        contentName: `Waiver - ${organizationName || 'Booking'}`,
        customData: { waiver_version: waiverVersion, verification_method: p.verificationMethod },
      });
    }
  };

  return (
    <WaiverFlow
      layout="overlay"
      onClose={onClose}
      waiverText={customWaiverText || trip.waiverText || ''}
      branding={{
        name: orgBranding?.name || organizationName,
        logoUrl: orgBranding?.logoUrl,
        brandColor,
        waiverVersion,
      }}
      onSubmit={handleSubmit}
      successAction="reload"
      region={region}
    />
  );
};

export default MobileWaiverWizard;
